module.exports = __webpack_public_path__ + "static/media/symbol-pen.8e0a5b76.svg";